








import React from "react";
import "../../styles/IndianProjectExpress.css";
import projectImage from "../../images/Indian-slider.jpg";
import project1 from "../../assets/project1.jpg";
import project2 from "../../assets/project2.jpg";
import projectIcon from "../../assets/service-icon.png"; // Import the icon
import { Link } from "react-router-dom";

const IndianProjectExpress = () => {
  return (
    <div className="express-container">
      {/* Image Slider - Full width like homepage */}
      <div className="express-image-slider">
        <img src={projectImage} alt="Indian Project Express Slider" />
      </div>

      {/* Main Content Container */}
      <div className="express-content">
        {/* Content Card with title inside */}
        <div className="express-card">
          {/* Title with Icon - Added with blue style */}
          <div className="express-title-header">
            <img src={projectIcon} alt="Project Express Service" className="express-title-icon rotate-on-hover" />
            <h3 className="express-title-text">Indian Project Express</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="card-left">
            <div className="express-image-container first-image">
              <img src={project1} alt="Project Cargo" className="express-img" />
            </div>
            <div className="express-image-container second-image">
              <img src={project2} alt="Project Cargo Handling" className="express-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="card-right">
            <p className="express-text">
              Puyvast is one of the few companies who can offer a total package of specialized project transport, 
              which can be adapted to the specific requirements of the client.
            </p>
            <p className="express-text">
              A diversified fleet of suitably geared vessels available with the Group, and in-house experience of 
              the technical department, represents the backbone of Puyvast's integrated project transport expertise.
            </p>
            <p className="express-text">
              The Puyvast Team offers a great variety of value-added services in the field of project and heavy 
              lift transport, ensuring a reliable alternative to this trade, and those requiring a total turnkey transport.
            </p>
            
            {/* Blue header for project list */}
            <div className="express-blue-header">
              <img src={projectIcon} alt="Project List" className="express-header-icon rotate-on-hover" />
              <div className="express-vertical-line"></div>
              <h3 className="express-header-title">A partial list of project shipments executed include:</h3>
            </div>
            
            <ul className="express-list">
              <li>📦 Relocation of a chemical plant from Karwar to Egypt on a turnkey basis.</li>
              <li>📦 Offshore oil rig from Vizag to Oman.</li>
              <li>📦 Locomotives & Coaches from Chennai to Sri Lanka & Africa.</li>
              <li>📦 Dumpers, Dozers, Excavators from Chennai to Syria & Tunisia as well as to South East Asian Ports.</li>
              <li>📦 Transformers from Chennai to Syria.</li>
              <li>📦 Transmission towers from Mumbai to Tripoli.</li>
              <li>📦 Chemical plant from Chennai to Aqaba.</li>
              <li>📦 Wind mill blades from Chennai to Kellysburg.</li>
              <li>📦 Construction and Mining equipment from Chennai & Kolkata to Africa and South East Asia.</li>
              <li>📦 Dismantled Cement Plant from Chennai to Lobito, West Africa.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer - Same as homepage */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town, <br></br>Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default IndianProjectExpress;